<template>

  <div class="layout">
    <div class="sidebar">
      <v-select :options="fgList" v-model="selectedFG" placeholder="Type to search..." :clearable="true"/>
        <div v-if="selectedFG">
        <strong>Stock:      </strong>{{ stockMap[selectedFG] !== undefined ? stockMap[selectedFG].stock : 'N/A' }}
        <br>
        <strong>FG Outstanding:  </strong><span>{{ fgOutstanding !== null ? fgOutstanding : 'N/A' }}</span>
        <br>
        <div :class="FGNetAvailableClass()"><strong>Net Available:    </strong><span>{{ FGNetAvailable() }}</span></div>
        <strong>Reorder Level:     </strong>{{ stockMap[selectedFG] !== undefined ? stockMap[selectedFG].reorderLevel : 'N/A' }}
      </div>
      <!-- Add this section before FG Outstanding Orders -->
      <div v-if="selectedFGPOListLoading">Loading FG PO List...</div>
      <div v-else-if="selectedFGPOListError">{{ selectedFGPOListError }}</div>
      <div v-else-if="selectedFGPOList.length">
        <strong>FG PO List:</strong>
        <div>
          <strong>Total Pending Qty:</strong>
          {{ selectedFGPOList.reduce((sum, row) => sum + (Number(row.G) || 0), 0) }}
        </div>
        <table class="sidebar-table">
          <thead>
            <tr>
              <th>PO No.</th>
              <th>PO Date</th>
              <th>Supplier</th>
              <th>Ordered Qty</th>
              <th>Pending Qty</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, idx) in selectedFGPOList" :key="idx">
              <td>{{ row.B }}</td>
              <td>{{ row.C }}</td>
              <td>{{ row.D }}</td>
              <td>{{ row.F }}</td>
              <td>{{ row.G }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else-if="selectedFG && !selectedFGPOListLoading">
        <strong>FG PO List:</strong> <em>No PO Found</em>
      </div>
      <div v-if="fgOutstandingOrdersLoading">Loading FG Outstanding Orders...</div>
      <div v-else-if="fgOutstandingOrdersError">{{ fgOutstandingOrdersError }}</div>
      <div v-else-if="fgOutstandingOrders.length">
        <strong>FG Outstanding Orders:</strong>
        <table class="sidebar-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>OA</th>
              <th>Pending Qty</th>
              <th>Customer</th>
              <th>Due</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="order in fgOutstandingOrders" :key="order.OA" :class="statusRowClass(order)">
              <td>{{ order.date }}</td>
              <td>
                <span
                  style="cursor:pointer; color:#007bff; text-decoration:underline;"
                  @click="openOAModal(order.OA)"
                >
                  {{ order.OA }}
                </span>
              </td>
              <td>{{ order.pendingQty }}</td>
              <td>{{ order.customerName }}</td>
              <td>{{ order.dueDate }}</td>
              <td>
                <span v-if="order.fgStatus === 'Not Enough FG'">
                  {{ componentOutstandingQ[order.index] !== undefined ? componentOutstandingQ[order.index] : '...' }}
                </span>
                <span v-else>
                  {{ order.fgStatus }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <em>No outstanding orders.</em>
      </div>
    </div>
    <div class="body">
      <div v-if="bomBLoading">Loading related items...</div>
      <div v-else-if="bomBError">{{ bomBError }}</div>
      <div class="table-scroll-x">
      <table v-if="bomBList.length && selectedFG" class="bom-table">
        <thead>
          <tr>
            <th>Info</th>
            <th v-for="item in bomBList" :key="item.component">{{ item.component}}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
          <td><strong>Purchase Tag</strong></td>
          <td v-for="item in bomBList" :key="item.component + '-tag'">
            {{ purchaseTagMap[item.component] !== undefined ? purchaseTagMap[item.component] : 'N/A' }}
          </td>
        </tr>
          <tr>
            <td><strong>Godown Info</strong></td>
            <td class="godown-info-cell" v-for="item in bomBList" :key="item.component + '-godown'">
              <span v-if="godownMap[item.component] && godownMap[item.component].length">
                <ul style="padding-left:0; margin:0; list-style:none;">
                  <li v-for="(g, idx) in godownMap[item.component]" :key="idx">
                    {{ g.qty }} - {{ g.godown }}
                  </li>
                </ul>
              </span>
              <span v-else>
                N/A
              </span>
            </td>
          </tr>
          <tr>
            <td><strong>Stock</strong></td>
            <td v-for="item in bomBList" :key="item.component + '-stock'">
              <span v-if="purchaseTagMap[item.component] === 'Bin System'"></span>
              <span v-else>
                {{
                  stockMap[item.component] && stockMap[item.component].stock !== undefined
                    ? stockMap[item.component].stock
                    : 'N/A'
                }}
              </span>
            </td>
          </tr>
          <tr>
            <td><strong>Component Outstanding</strong></td>
            <td v-for="item in bomBList" :key="item.component + '-out'">
              {{ componentOutstandingMap[item.component] !== undefined ? componentOutstandingMap[item.component] : 'N/A' }}
            </td>
          </tr>
          <tr>
            <td><strong>Net Available</strong></td>
            <td v-for="item in bomBList" :key="item.component + '-net'" :class="netAvailableClass(item)">
              <span v-if="purchaseTagMap[item.component] === 'Bin System'"></span>
              <span v-else>
                {{
                  (stockMap[item.component] && typeof stockMap[item.component].stock === 'number' && typeof componentOutstandingMap[item.component] === 'number')
                    ? stockMap[item.component].stock - componentOutstandingMap[item.component]
                    : (
                        (stockMap[item.component] && !isNaN(Number(stockMap[item.component].stock)) && !isNaN(Number(componentOutstandingMap[item.component])))
                          ? Number(stockMap[item.component].stock) - Number(componentOutstandingMap[item.component])
                          : 'N/A'
                      )
                }}
              </span>
            </td>
            </tr>
            <tr>
            <td><strong>Reorder Level</strong></td>
            <td v-for="item in bomBList" :key="item.component + '-reorder'">
              {{
                stockMap[item.component] && stockMap[item.component].reorderLevel !== undefined
                  ? stockMap[item.component].reorderLevel
                  : 'N/A'
              }}
            </td>
          </tr>
        <tr>
          <td><strong>PO Orders</strong></td>
          <td v-for="item in bomBList" :key="item.component + '-po-orders'">
            <div v-if="poOrders && poOrders.length">
              <span
                style="cursor:pointer; color: #007bff; text-decoration: underline;"
                @click="openPOModal(item.component)"
              >
              {{ getPOQtySum(item.component) }}
              </span>
              <transition name="fade">
                <div v-if="isPOCollapsed(item.component)" style="margin-top: 6px;">
                  <ul class="po-orders-list" style="padding-left: 0; list-style: none; max-height: 120px; overflow-y: auto;">
                    <li
                      v-for="order in poOrders.filter(po => po.item === item.component)"
                      :key="order.poNumber + '-' + order.poDate"
                      style="background: #f9f9f9; border: 1px solid #ddd; border-radius: 4px; margin-bottom: 4px; padding: 4px;"
                    >
                      <span>
                        PO#: {{ order.poNumber }}<br>
                        Date: {{ order.poDate }}<br>
                        Supplier: {{ order.supplier }}<br>
                        Qty: {{ order.qtyOrdered }}
                      </span>
                    </li>
                  </ul>
                </div>
              </transition>
            </div>
            <div v-else>
              <em>No PO</em>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div v-if="poModal.open" class="po-modal-overlay" @click.self="closePOModal">
        <div class="po-modal">
          <h3>PO Orders for {{ poModal.component }}</h3>
          <button @click="closePOModal" class="close-btn">Close</button>
          <ul class="po-orders-list">
            <li
              v-for="order in poOrders.filter(po => po.item === poModal.component)"
              :key="order.poNumber + '-' + order.poDate"
              style="background: #f9f9f9; border: 1px solid #ddd; border-radius: 4px; margin-bottom: 4px; padding: 4px;"
            >
              <span>
                PO#: {{ order.poNumber }}<br>
                Date: {{ order.poDate }}<br>
                Supplier: {{ order.supplier }}<br>
                Qty: {{ order.qtyOrdered }}
              </span>
            </li>
            <li v-if="!poOrders.filter(po => po.item === poModal.component).length">
              <em>No PO</em>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="oaModal.open" class="po-modal-overlay" @click.self="closeOAModal">
        <div class="po-modal">
          <h3>OA Details for {{ oaModal.oaNumber }}</h3>
          <button @click="closeOAModal" class="close-btn">Close</button>
          <div v-if="oaModal.loading">Loading...</div>
          <div v-else-if="oaModal.error">{{ oaModal.error }}</div>
          <div v-else-if="oaModal.details.length">
            <table class="sidebar-table">
              <thead>
                <tr>
                  <th>OrderDate</th>
                  <th>Particulars</th>
                  <th>OrderQty</th>
                  <th>PendingQty</th>
                  <th>FGStockLevel</th>
                  <th>FGStatus</th>
                  <th>ComponentStatus</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, idx) in oaModal.details" :key="idx">
                  <td>{{ row.OrderDate }}</td>
                  <td>{{ row.Particulars }}</td>
                  <td>{{ row.OrderQty }}</td>
                  <td>{{ row.PendingQty }}</td>
                  <td>{{ row.FGStockLevel }}</td>
                  <td>{{ row.FGStatus }}</td>
                  <td>{{ row.ComponentStatus }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            <em>No details found for this OA number.</em>
          </div>
        </div>
      </div>
      <div v-else-if="bomBList.length === 0 && selectedFG">No items found for this FG.</div>
    </div>
    </div>
  </div>
</template>

<script>
const backendUrl = process.env.VUE_APP_BACKEND_URL;
console.log('Backend URL:', backendUrl);
import vSelect from "vue3-select";
import "vue3-select/dist/vue3-select.css";

export default {
  name: 'FinishedGoodsAnalysis',
  components: { vSelect },
  props: {
    msg: String
  },
  data() {
    return {
      fgList: [],
      selectedFG: null,
      restoredFG: false, // helper flag
      fgLoading: false,
      fgError: '',
      bomBList: [],
      bomBLoading: false,
      bomBError: '',
      stockMap: {},
      stockLoading: false,
      stockError: '',
      fgOutstanding: null,
      fgOutstandingLoading: false,
      fgOutstandingError: '',
      componentOutstandingMap: {},
      componentOutstandingLoading: false,
      componentOutstandingError: '',
      purchaseTagMap: {},
      fgOutstandingOrders: [],
      fgOutstandingOrdersLoading: false,
      fgOutstandingOrdersError: '',
      poOrders: [],
      poOrdersCollapse: {},
      poModal: {open: false, component: null,},
      godownMap: {},
      componentOutstandingQ: {},
      oaModal: {open: false, oaNumber: null, details: [], loading: false, error: ''},
      selectedFGPOList: [],      // PO list for selected FG
      selectedFGPOListLoading: false,
      selectedFGPOListError: '',
    }
  },
  methods: {
    async getFGSelection() {
      this.fgLoading = true;
      this.fgError = '';
      try {
        // Fetch the FG Req data from your backend
        const response = await fetch(`${backendUrl}/excel/fg-req`);
        if (!response.ok) throw new Error('Failed to fetch FG Req list');
        const data = await response.json();
        // Extract Column A from each row
        this.fgList = (data.items || [])
          .map(row => row[0]) // Column A
          .filter(item => item !== undefined && item !== null && item !== '');
        console.log('FG List:', this.fgList);
        this.fgError = '';
      } catch (err) {
        this.fgError = err.message;
        this.fgList = [];
      } finally {
        this.fgLoading = false;
        // Restore selectedFG from localStorage after fgList is loaded
        if (!this._restoredFG) {
          const savedFG = localStorage.getItem('selectedFG');
          if (savedFG && this.fgList.includes(savedFG)) {
            this.selectedFG = savedFG;
          }
          this._restoredFG = true;
        }
      }
    },
    
    async fetchBOM() {
      if (!this.selectedFG) {
        this.bomBList = [];
        return;
      }
      this.bomBLoading = true;
      this.bomBError = '';
      try {
        const response = await fetch(`${backendUrl}/excel/bomdata/ComponentBOMQtyHeirarchy`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ fg: this.selectedFG })
        });
        if (!response.ok) throw new Error('Failed to fetch BOM data');
        const data = await response.json();
        this.bomBList = data.items || [];
      } catch (err) {
        this.bomBError = err.message;
        this.bomBList = [];
      } finally {
        this.bomBLoading = false;
      }
    },

  async fetchStockMap() {
  this.stockLoading = true;
  this.stockError = '';
  try {
    const response = await fetch(`${backendUrl}/excel/StockReorder`);
    if (!response.ok) throw new Error('Failed to fetch stock levels');
    const data = await response.json();
    this.stockMap = data.stockMap || {};
  } catch (err) {
    this.stockError = err.message;
    this.stockMap = {};
  } finally {
    this.stockLoading = false;
  }
  },

  async fetchFGOutstanding() {
      if (!this.selectedFG) {
        this.fgOutstanding = null;
        return;
      }
      this.fgOutstandingLoading = true;
      this.fgOutstandingError = '';
      try {
        const response = await fetch(`${backendUrl}/excel/bomdata/fg-outstanding`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ fg: this.selectedFG })
        });
        if (!response.ok) throw new Error('Failed to fetch FG Outstanding');
        const data = await response.json();
        this.fgOutstanding = data.fgOutstanding;
      } catch (err) {
        this.fgOutstandingError = err.message;
        this.fgOutstanding = null;
      } finally {
        this.fgOutstandingLoading = false;
      }
    },

  async fetchFGOutstandingOrders() {
      if (!this.selectedFG) {
        this.fgOutstandingOrders = [];
        return;
      }
      this.fgOutstandingOrdersLoading = true;
      this.fgOutstandingOrdersError = '';
      try {
        const response = await fetch(`${backendUrl}/excel/bomdata/FGOutstandingOrders`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ fg: this.selectedFG })
        });
        if (!response.ok) throw new Error('Failed to fetch FG Outstanding Orders');
        const data = await response.json();
        this.fgOutstandingOrders = data.items || [];
      } catch (err) {
        this.fgOutstandingOrdersError = err.message;
        this.fgOutstandingOrders = [];
      } finally {
        this.fgOutstandingOrdersLoading = false;
      }
    },

  async fetchComponentOutstanding() {
      if (!this.selectedFG) {
        this.componentOutstandingMap = {};
        return;
      }
      this.componentOutstandingLoading = true;
      this.componentOutstandingError = '';
      try {
        const response = await fetch(`${backendUrl}/excel/bomdata/component-outstanding`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ fg: this.selectedFG })
        });
        if (!response.ok) throw new Error('Failed to fetch Component Outstanding');
        const data = await response.json();
        this.componentOutstandingMap = data.componentOutstanding || {};
      } catch (err) {
        this.componentOutstandingError = err.message;
        this.componentOutstandingMap = {};
      } finally {
        this.componentOutstandingLoading = false;
      }
    },

  async fetchPurchaseTags() {
  if (!this.bomBList.length) {
    this.purchaseTagMap = {};
    return;
  }
  const components = this.bomBList.map(item => item.component);
  const params = new URLSearchParams({ items: components.join(',') });
  const response = await fetch(`${backendUrl}/excel/purchase-tags?${params}`);
  const data = await response.json();
  this.purchaseTagMap = data.purchaseTagMap || {};
  },

  async fetchPOOrders() {
  if (!this.bomBList.length) {
    this.poOrders = [];
    return;
  }
  console.log('Sending bomBList:', this.bomBList.map(item => item.component));
  try {
    const response = await fetch(`${backendUrl}/excel/po-list/orders`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ bomBList: this.bomBList.map(item => item.component) })
    });
    if (!response.ok) throw new Error('Failed to fetch PO Orders');
    const data = await response.json();
    this.poOrders = data.items || [];
  } catch (err) {
    this.poOrders = [];
    // Optionally, handle error state here
  }
  },

  togglePOCollapse(component) {
  this.poOrdersCollapse[component] = !this.poOrdersCollapse[component];
  },
  isPOCollapsed(component) {
    return !!this.poOrdersCollapse[component];
  },
  getPOQtySum(component) {
    return this.poOrders
      .filter(po => po.item === component)
      .reduce((sum, po) => sum + Number(po.qtyOrdered || 0), 0);
  },
    openPOModal(component) {
    this.poModal.open = true;
    this.poModal.component = component;
  },
  closePOModal() {
    this.poModal.open = false;
    this.poModal.component = null;
  },

  async fetchGodownInfo() {
  if (!this.bomBList.length) {
    this.godownMap = {};
    return;
  }
  try {
    const response = await fetch(`${backendUrl}/excel/godown-info`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ bomBList: this.bomBList.map(item => item.component) })
    });
    const data = await response.json();
    this.godownMap = data.godownMap || {};
  } catch (err) {
    this.godownMap = {};
  }
  },

  async fetchComponentOutstandingQ(indexes) {
  if (!indexes.length) {
    this.componentOutstandingQ = {};
    return;
  }
  try {
    const response = await fetch(`${backendUrl}/excel/component-outstanding/by-index`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ indexes })
    });
    const data = await response.json();
    this.componentOutstandingQ = data.result || {};
  } catch (err) {
    this.componentOutstandingQ = {};
  }
  },

  async openOAModal(oaNumber) {
  this.oaModal.open = true;
  this.oaModal.oaNumber = oaNumber;
  this.oaModal.details = [];
  this.oaModal.loading = true;
  this.oaModal.error = '';
  try {
    const response = await fetch(`${backendUrl}/excel/oa-registrar-details`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ oaNumbers: [oaNumber] })
    });
    const data = await response.json();
    this.oaModal.details = data.result || [];
  } catch (err) {
    this.oaModal.error = 'Failed to fetch OA details.';
  } finally {
    this.oaModal.loading = false;
  }
  },

  closeOAModal() {
    this.oaModal.open = false;
    this.oaModal.oaNumber = null;
    this.oaModal.details = [];
    this.oaModal.loading = false;
    this.oaModal.error = '';
  },

  statusRowClass(order) {
    let status = order.fgStatus;
    if (status === 'Not Enough FG') {
      // Use the value from componentOutstandingQ[order.index] if it exists
      status = this.componentOutstandingQ[order.index];
    }
    if (status === 'FG Ready') return 'status-green-row';
    if (status === 'Casting Available') return 'status-purple-row';
    if (status === 'Casting Short') return 'status-red-row';
    if (status === 'Machined Available') return 'status-cyan-row';
    return '';
  },

  netAvailableClass(item) {
    if (this.purchaseTagMap[item.component] === 'Bin System') return '';
    const stock = this.stockMap[item.component]?.stock;
    const outstanding = this.componentOutstandingMap[item.component];
    const stockNum = Number(stock);
    const outstandingNum = Number(outstanding);
    if (!isNaN(stockNum) && !isNaN(outstandingNum) && (stockNum - outstandingNum) < 0) {
      return 'negative-net-cell';
    }
    return '';
  },

  FGNetAvailable() {
    const stock = (this.stockMap[this.selectedFG]?.stock ?? 0);
    const outstanding = (this.fgOutstanding ?? 0);
    return stock - outstanding;
  },

  FGNetAvailableClass() {
    const value = this.FGNetAvailable();
    return (!isNaN(value) && Number(value) < 0) ? 'negative-net-text' : '';
  },

  async fetchFGPOList() {
    if (!this.selectedFG) {
      this.selectedFGPOList = [];
      return;
    }
    this.selectedFGPOListLoading = true;
    this.selectedFGPOListError = '';
    try {
      const response = await fetch(`${backendUrl}/excel/po-list/by-component`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ component: this.selectedFG }) // Use 'component' key but pass FG value
      });
      if (!response.ok) throw new Error('Failed to fetch FG PO List');
      const data = await response.json();
      this.selectedFGPOList = data.poList || [];
    } catch (err) {
      this.selectedFGPOListError = err.message;
      this.selectedFGPOList = [];
    } finally {
      this.selectedFGPOListLoading = false;
    }
  },

  },
  
watch: {
  selectedFG(newVal) {
    if (newVal !== null && newVal !== undefined) {
      localStorage.setItem('selectedFG', newVal);
    } else {
      localStorage.removeItem('selectedFG');
    }
    this.fetchBOM();
    this.fetchFGOutstanding();
    this.fetchComponentOutstanding();
    this.fetchFGOutstandingOrders();
    this.fetchFGPOList();
  },
  bomBList() {
  this.fetchPurchaseTags();
  this.fetchPOOrders();
  this.fetchGodownInfo();
},
fgOutstandingOrders(newOrders) {
  const indexes = (newOrders || [])
    .filter(order => order.fgStatus === "Not Enough FG")
    .map(order => order.index);
  this.fetchComponentOutstandingQ(indexes);
},
},

  mounted() {
    this.getFGSelection();
    this.fetchStockMap();
    this.fetchFGOutstanding();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Layout */
.layout {
  display: flex;
  gap: 2.5em;
  align-items: flex-start;
  min-height: 100vh;
  padding: 2em 0;
}

/* Sidebar */
.sidebar {
  width: 400px;
  border-radius: 14px;
  box-shadow: 0 2px 16px #0001;
  padding: 2em 1.5em 1.5em 1.5em;
  font-family: 'Segoe UI', Arial, sans-serif;
  color: #222;
  display: flex;
  flex-direction: column;
  gap: 1.5em;
  font-size: 1.2em;
}

.negative-net-text {
  color: #d90429 !important;
  font-weight: bold;
}

.sidebar strong {
  color: #2b6cb0;
  font-weight: 600;
}

.sidebar-table {
  width: 400px;
  border-collapse: collapse;
  margin-top: 1em;
  font-size: 0.8em;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 4px #0001;
}

.sidebar-table th, .sidebar-table td {
  border: 1px solid #e2e8f0;
  padding: 0.5em 0.75em;
  text-align: left;
}

.sidebar-table th {
  background: #e9eef6;
  color: #2b6cb0;
  font-weight: 600;
}

.status-green-row {
  background-color: #e6f9ed !important;
  color: #137333 !important;
  font-weight: bold;
}
.status-purple-row {
  background-color: #f3e8fd !important;
  color: #7c3aed !important;
  font-weight: bold;
}
.status-red-row {
  background-color: #fde8e8 !important;
  color: #d90429 !important;
  font-weight: bold;
}
.status-cyan-row {
  background-color: #e0f7fa !important;
  color: #00838f !important;
  font-weight: bold;
}

/* Main body */
.body {
  flex: 1;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 16px #0001;
  padding: 2em 2em 1.5em 2em;
  font-family: 'Segoe UI', Arial, sans-serif;
  color: #222;
  min-width: 0;
}

.bom-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1em;
  font-size: 0.8em;
  background: #f9fafb;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 4px #0001;
}

.bom-table th, .bom-table td {
  border: 1px solid #e2e8f0;
  padding: 0.6em 0.85em;
  text-align: left;
}

.bom-table th {
  background: #e9eef6;
  color: #2b6cb0;
  font-weight: 600;
}

.bom-table tr:nth-child(even) {
  background: #f4f7fb;
}

.negative-net-cell {
  background: #fde8e8 !important;
  color: #d90429 !important;
  font-weight: bold;
}

.godown-info-cell ul {
  padding-left: 0;
  margin: 0;
  list-style: none;
}

.godown-info-cell li {
  margin-bottom: 2px;
  color: #444;
}

.po-orders-list {
  font-size: 13px;
  line-height: 1.4;
}

.po-modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.18);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.po-modal {
  background: #fff;
  padding: 28px 36px;
  border-radius: 10px;
  min-width: 340px;
  max-width: 95vw;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 6px 32px rgba(0,0,0,0.18);
  position: relative;
}

.close-btn {
  position: absolute;
  top: 12px;
  right: 16px;
  background: #e2e8f0;
  border: none;
  border-radius: 4px;
  padding: 5px 12px;
  cursor: pointer;
  font-weight: 600;
  color: #2b6cb0;
  transition: background 0.2s;
}
.close-btn:hover {
  background: #cbd5e1;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

/* Misc */
em {
  color: #888;
}

.table-scroll-x {
  width: 100%;
  overflow-x: auto;
}
.bom-table {
  min-width: 900px; /* or higher if needed */
  width: max-content;
}

[v-cloak] { display: none; }
</style>